import i18n from "i18next";
import {initReactI18next} from "react-i18next";

import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import {configuration} from "./config/config";

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en", // use en if detected lng is not available
        ns: ["common"],
        debug: process.env.NODE_ENV === "development",
        interpolation: {
            escapeValue: false,
            prefix: "{{.",
        },
        react: {
            useSuspense: false,
        },
        detection: {
            order: ["querystring", "cookie", "localStorage", "sessionStorage", "navigator", "htmlTag"],
            lookupQuerystring: "lng",
        },
        load: "languageOnly",
        backend: {
            loadPath: configuration.apiUrl + "/i18n/namespaces/{{.ns}}/translations?languageCode={{.lng}}",
            crossDomain: true,
        },
    });

export default i18n;
